import dayjs from 'dayjs';
import { HoursStatus } from '@application/common/enums/hours-status';
// The hour-registration page always shows dates in English, independent of
// the global moment/dayjs/i18n locale (which can render Dutch month names).
const en = (date) => dayjs(date).locale('en');
export const formatDisplayDate = (date) => {
    if (date === null || date === undefined || date === '')
        return '';
    const parsed = en(date);
    return parsed.isValid() ? parsed.format('D MMM YYYY') : '';
};
// Short English day label for table rows: "Mon 1 Oct".
export const formatDayLabel = (date) => {
    if (date === null || date === undefined || date === '')
        return '';
    const parsed = en(date);
    return parsed.isValid() ? parsed.format('ddd D MMM') : '';
};
// Compact English range: "1–4 Oct", "29 Sep – 5 Oct", "29 Dec 2026 – 4 Jan 2027".
export const formatShortRange = (from, to) => {
    if (!from)
        return '';
    const start = en(from);
    if (!start.isValid())
        return '';
    const end = to ? en(to) : start;
    if (!end.isValid() || start.isSame(end, 'day'))
        return start.format('D MMM');
    if (start.year() !== end.year())
        return `${start.format('D MMM YYYY')} – ${end.format('D MMM YYYY')}`;
    if (start.month() !== end.month())
        return `${start.format('D MMM')} – ${end.format('D MMM')}`;
    return `${start.format('D')}–${end.format('D MMM')}`;
};
export const formatMonthYear = (month, year) => en(`${year}-${String(month).padStart(2, '0')}-01`).format('MMMM YYYY');
export const formatShortMonthYear = (month, year) => en(`${year}-${String(month).padStart(2, '0')}-01`).format('MMM YYYY');
// A week or day only says whether it is filled in. Review statuses belong to months.
export const isWeekFilled = (status) => status === HoursStatus.Complete || status === HoursStatus.Pending || status === HoursStatus.Approved || status === HoursStatus.Rejected;
// Month statuses shown to professionals: Open, Pending, Rejected or Approved.
// "Complete" means every week is filled in but the month was not sent yet, so it is still Open.
export const monthStatusLabel = (status) => {
    if (status === null || status === undefined)
        return undefined;
    if (status === HoursStatus.Complete)
        return HoursStatus[HoursStatus.Open];
    return HoursStatus[status];
};
